import { apiDev } from '@/scripts/axios';
import { catchError } from '@/scripts/utils/store-dependent';

const createReferral = () =>
  apiDev
    .get(`partnershipProgram/referralID`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getReferralStats = params =>
  apiDev
    .get(`partnershipProgram/stats`, { params })
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getReferralsList = params =>
  apiDev
    .get(`partnershipProgram/earnings`, { params })
    .then(({ data: { response } }) => response)
    .catch(catchError);

const registerReferralLinkClick = referrerID =>
  apiDev
    .post(`partnershipProgram/click`, { referrerID })
    .then(({ data: { response } }) => response)
    .catch(catchError);

export {
  createReferral,
  getReferralStats,
  getReferralsList,
  registerReferralLinkClick,
};
